import en from "./repo/en";
import tr from "./repo/tr";

export default {
  en: en,
  tr: tr
}